<va-filtered-mat-table
  [tableDataService]="userListsOverviewService"
  limitContentHeightForDesktop="false"
  class="user-lists-table"
>
  <va-filtered-mat-table-actions>
    <a
      class="header-button"
      id="import-user-list"
      mat-flat-button
      color="primary"
      [routerLink]="userListImportUrl"
    >
      Import List
    </a>
  </va-filtered-mat-table-actions>
</va-filtered-mat-table>
